<template>
  <div>
    <b-row>
      <b-col sm="12" md="12" v-if="checkAccessPrivilege('JeetPrivilege.SportsCashback.Query')">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-calendar'></i> Period</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="startDate">Start </label>
              <b-input id="startDate" type="date" placeholder="" v-model="startDate" :state="$v.startDate.$error?false:null" @blur.native="$v.startDate.$touch"></b-input>
              <div v-if="$v.startDate.$error">
                <div class="invalid-feedback d-block" v-if="!$v.startDate.required">&nbsp;&nbsp; Required &nbsp;&nbsp;</div>
              </div>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="endDate">End </label>
              <b-input id="endDate" type="date" placeholder="" v-model="endDate" :state="$v.endDate.$error?false:null" @blur.native="$v.endDate.$touch"></b-input>
              <div v-if="$v.endDate.$error">
                <div class="invalid-feedback d-block" v-if="!$v.endDate.required">&nbsp;&nbsp; Required &nbsp;&nbsp;</div>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="query" :disabled="$v.startDate.$invalid || $v.endDate.$invalid"><i class="fa fa-search"></i> Query</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-inr'></i> Sports Cashback Report</h3>
              <h5 class="float-right" style="margin-left: 10px"> Total Cashback: {{format(totalCashback, '0,0.00')}}</h5>
              <b-button class="float-right" variant="primary" @click="exportCSV" :disabled="items.length === 0" v-if="checkAccessPrivilege('JeetPrivilege.SportsCashback.Export')">Export</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(SportsNetWin)="data">
                <span>{{format(data.item.SportsNetWin, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(TotalNetWin)="data">
                <span>{{format(data.item.TotalNetWin, '0,0.00')}}</span>
              </template>
              <!-- <template v-slot:cell(TotalPromotionNetWin)="data">
                <span>{{format(data.item.TotalPromotionNetWin, '0,0.00')}}</span>
              </template> -->
              <template v-slot:cell(Cashback)="data">
                <span>{{format(data.item.Cashback, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(TotalCashback)="data">
                <span>{{format(data.item.TotalCashback, '0,0.00')}}</span>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import numeral from 'numeral'
  import moment from 'moment-timezone'
  import {Events} from '../../../../events.js'
  const {required} = require('vuelidate/lib/validators')
  export default {
    name: 'cashback-report-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'MemberId', label: 'Member ID'},
          {key: 'Username', label: 'Username'},
          {key: 'SportsNetWin', label: 'Sports Losing'},
          {key: 'TotalNetWin', label: 'Total Losing'},
          // {key: 'TotalPromotionNetWin', label: 'Total Promo. Losing'},
          {key: 'Cashback', label: '5% Cashback'},
          {key: 'TotalCashback', label: 'Final Cashback'}
        ],
        currentPage: 1,
        perPage: 20,
        totalCashback: 0,
        startDate: '',
        endDate: ''
      }
    },
    validations: {
      startDate: { required },
      endDate: { required }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      exportCSV () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashback/sports/csv', {startDate: this.startDate, endDate: this.endDate}, {responseType: 'blob', headers: { 'Content-Type': 'application/json' }}).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `sports_cashback_${moment(this.startDate).format('YYYYMMDD')}_${moment(this.endDate).format('YYYYMMDD')}.csv`)
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getRowCount (items) {
        return items.length
      },
      query () {
        this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashback/sports', {startDate: this.startDate, endDate: this.endDate}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
          this.totalCashback = response.data.totalCashback
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/sportsReport/SportsReportTable.vue